import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile px-10 my-20" }
const _hoisted_2 = { class: "profile__wrapper text-center pa-40" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "text-gradient text-center mb-20 d-inline-flex" }, "Интерфейс", -1)
const _hoisted_5 = { class: "profile-actions" }

import router from '@/router'
import BackLine from '@/components/Lines/BackLine.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import InterfaceSlider from '@/components/Sliders/InterfaceSlider.vue'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import SocLinks from '@/components/SocLinks.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileInterfaceView',
  setup(__props) {


const userStore = useUserStore()

const { user: userProfile } = storeToRefs(userStore)

const setDefaultTheme = async () => {
  const container = document.getElementById('app')
  if (container) {
    container.setAttribute('theme', 'b')
    await userStore.setTheme('b')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackLine, null, {
      default: _withCtx(() => [
        _createVNode(CircleButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
          name: "chevron-left-gradient",
          bg: "empty",
          iconWidth: 21,
          iconHeight: 16,
          "view-box": "0 0 21 16"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(userProfile)?.name || ''), 1),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BaseButton, {
            onClick: setDefaultTheme,
            class: "large rounded margin-auto mb-20 full-width",
            bg: "gradient",
            border: "gradient"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Вернуть по умолчанию")
            ]),
            _: 1
          }),
          _createVNode(BaseButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).go(-1))),
            class: "large rounded margin-auto mb-20 full-width",
            bg: "none",
            border: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Назад")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(InterfaceSlider),
      _createVNode(SocLinks)
    ])
  ], 64))
}
}

})